import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function About() {
  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Safety & Compliance',
      description: 'We maintain the highest safety standards and full regulatory compliance in all operations.',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Customer Focus',
      description: 'Our clients\' success is our priority, delivering tailored solutions that meet specific needs.',
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Innovation',
      description: 'Leveraging advanced technology and modern infrastructure for optimal efficiency.',
    },
    {
      icon: 'ri-team-line',
      title: 'Expertise',
      description: 'Decades of industry experience with highly trained professionals.',
    },
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-grow">
        {/* Hero Section */}
        <section 
          className="relative bg-cover bg-center h-96 flex items-center"
          style={{
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://public.readdy.ai/ai/img_res/98c2d874547fd8f3f77c9702b85ac956.jpg')`
          }}
        >
          <div className="max-w-7xl mx-auto px-6 lg:px-12 w-full">
            <h1 className="text-5xl font-bold text-white mb-4">About TONCENT</h1>
            <p className="text-xl text-gray-200 max-w-2xl">Leading provider of petroleum storage and shipping solutions</p>
          </div>
        </section>

        {/* Company Overview */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-4xl font-bold text-gray-900 mb-6">SHENZHEN TONCENT INT'L LOGISTICS CO.,LTD</h2>
                <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                  TONCENT is a premier international logistics company specializing in comprehensive petroleum storage and shipping solutions. With our state-of-the-art tank farm facilities and extensive transportation network, we serve clients worldwide with reliable, safe, and efficient services.
                </p>
                <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                  Our modern infrastructure includes a 100,000 m³ storage capacity tank farm, in-house laboratory facilities, and a controlled fleet of 31 vessels. We provide end-to-end solutions including storage, quality analysis, tank leasing, and multi-modal transportation services via maritime, railway, and motor transport.
                </p>
                <p className="text-lg text-gray-600 leading-relaxed">
                  Operating in full compliance with United States and international regulations, we prioritize safety, quality, and customer satisfaction in every aspect of our operations. Our advanced monitoring systems and experienced team ensure the integrity and security of your petroleum products throughout the entire logistics chain.
                </p>
              </div>
              <div>
                <img 
                  src="https://readdy.ai/api/search-image?query=Real%20professional%20petroleum%20tank%20farm%20facility%20with%20multiple%20large%20white%20storage%20tanks%20in%20organized%20rows%20at%20working%20terminal%2C%20authentic%20documentary%20photography%20of%20actual%20modern%20industrial%20infrastructure%20with%20clean%20pipelines%20and%20safety%20equipment%2C%20realistic%20aerial%20photograph%20of%20genuine%20oil%20terminal%20complex%20showing%20professional%20operations%20and%20organization%2C%20high%20quality%20photojournalism%20of%20actual%20petroleum%20storage%20facility%20demonstrating%20real%20safety%20standards%20and%20modern%20technology%20under%20natural%20daylight&width=600&height=700&seq=about002&orientation=portrait"
                  alt="TONCENT facilities"
                  className="rounded-2xl shadow-xl w-full h-auto object-cover object-top"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Our Values */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Core Values</h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                The principles that guide our operations and define our commitment to excellence
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {values.map((value, index) => (
                <div key={index} className="text-center group hover:scale-105 transition-transform duration-300">
                  <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:shadow-lg group-hover:shadow-teal-500/50 transition-shadow">
                    <i className={`${value.icon} text-3xl text-white`}></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-3">{value.title}</h3>
                  <p className="text-gray-600">{value.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Capabilities */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-12 text-center">Our Capabilities</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-gray-50 rounded-xl p-8">
                <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-database-2-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Storage Infrastructure</h3>
                <ul className="space-y-3 text-gray-600">
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line text-blue-600 mt-1"></i>
                    <span>100,000 m³ total storage capacity</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line text-blue-600 mt-1"></i>
                    <span>Dedicated fuel storage tanks</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line text-blue-600 mt-1"></i>
                    <span>Independent pipeline systems</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line text-blue-600 mt-1"></i>
                    <span>Real-time monitoring systems</span>
                  </li>
                </ul>
              </div>

              <div className="bg-gray-50 rounded-xl p-8">
                <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-ship-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Transportation Fleet</h3>
                <ul className="space-y-3 text-gray-600">
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line text-blue-600 mt-1"></i>
                    <span>31 vessel controlled fleet</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line text-blue-600 mt-1"></i>
                    <span>15 self-propelled vessels</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line text-blue-600 mt-1"></i>
                    <span>12 non-self-propelled barges</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line text-blue-600 mt-1"></i>
                    <span>4 push tugs + additional capacity</span>
                  </li>
                </ul>
              </div>

              <div className="bg-gray-50 rounded-xl p-8">
                <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-flask-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Quality Control</h3>
                <ul className="space-y-3 text-gray-600">
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line text-blue-600 mt-1"></i>
                    <span>In-house laboratory facilities</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line text-blue-600 mt-1"></i>
                    <span>Continuous product monitoring</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line text-blue-600 mt-1"></i>
                    <span>Precise quality analysis</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <i className="ri-check-line text-blue-600 mt-1"></i>
                    <span>Compliance verification</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-r from-blue-900 via-blue-800 to-teal-900">
          <div className="max-w-7xl mx-auto px-6 lg:px-12 text-center">
            <h2 className="text-4xl font-bold text-white mb-6">Partner with SHENZHEN TONCENT</h2>
            <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
              Experience the difference of working with a trusted petroleum logistics leader
            </p>
            <Link 
              to="/contact" 
              className="inline-block px-8 py-4 bg-teal-500 text-white font-semibold rounded-lg hover:bg-teal-600 transition-colors shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              Contact Us Today
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}